import axios from 'axios';
import { getAuthHeaders } from '../Auth';
import exportedConfig from '../config';

interface GenerateLogoParams {
    prompt?: string;
    tagLine?: string;
    businessName: string;
    industry?: string;
    businessDescription?: string;
    style?: string;
    creativity?: string;
    mediaType?: string;
    priority?: string;
    culture?: string;
    signal: AbortSignal;
}

interface GenerateLogoResponse {
    imageUrl: string;
    prompt: string;
}

export const postLogoUrl = async ({
    prompt,
    tagLine,
    businessName,
    industry,
    businessDescription,
    style,
    creativity,
    mediaType,
    priority,
    culture,
    signal,
}: GenerateLogoParams): Promise<GenerateLogoResponse> => {
    try {
        const headers = await getAuthHeaders();
        const response = await axios.post(
            `${exportedConfig.backendServiceUrl}/api/v3/inspiration:generateLogo`,
            {
                prompt,
                tagLine,
                businessName,
                industry,
                businessDescription,
                style,
                creativity,
                mediaType,
                priority,
                culture,
            },
            {
                signal,
                headers,
            },
        );

        if (!response.data) {
            throw new Error('Empty response from API');
        }

        if (!response.data.imageUrl) {
            console.error('API Response:', response.data);
            throw new Error('API response missing imageUrl field');
        }

        return {
            imageUrl: response.data.imageUrl,
            prompt: response.data.prompt || '',
        };
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('API Error:', error.response?.data || error.message);
            throw new Error(`API request failed: ${error.response?.data?.message || error.message}`);
        }
        console.error('Error generating image:', error);
        throw error;
    }
};
